module.exports = __webpack_public_path__ + "images/intro-8188b958debe7ae75c7f7794033baa7b.jpg";